import React, {Component} from 'react';

import classes from './intro.css';

import Aux from '../../hoc/auxilliary';

import vrcLogo from '../../assets/vrc-logo.PNG';

//import axios from '../../axios-orders';

import {connect} from 'react-redux';

import * as actions from '../../store/actions/exporter';


class Intro extends Component{
    
    componentDidMount(){
        
        //isExisting check wouldn't work here after reaching this page after Driverinfo page unmounts, because the state doesn't update before this component mounts (tested this)
    
        if(this.props.token && this.props.registered){
            
           
        this.props.onExistingSet(this.props.userId);
            
        }
        
    
    }
    
    
    render(){
        
        
    return(
        
        <Aux>


            <img src={vrcLogo} className={classes.VrcLogo} alt='VRC logo'/>


            <div className={classes.App}>



            <iframe title='promo' src="https://www.youtube.com/embed/SWFXmgCfOks" className={classes.Trailer} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

            </div>

        </Aux>
    
      
    
    );
        
    }
    

}

//width='480' hight='250'

const mapStateToProps=state=>{//mapStateToProps is commonly used name, but you could name it differently. The state is Redux state. Note: create this constant after the class above
    
    return {
        userId: state.auth.userId,
        token: state.auth.token,
        registered: state.reg.registered

    };
}

const mapDispatchToProps=dispatch=> {
    
    return {
        
        onExistingSet: (userId)=> dispatch(actions.existingStatusUpdate(userId))
        
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(Intro);


// WEBPACK FOOTER //
// ./src/components/Intro/intro.js